import { DateTime } from "luxon";

const EPCancelledInfo = ({ ep }) => {
  if (!ep.cancelledAt) return null;

  return (
    <div className="col-12 d-center flex-column p-3 bg-body mt-4">
      <p className="m-0">
        EP annulé le{" "}
        <strong>
          {DateTime.fromISO(ep.cancelledAt)
            .setLocale("FR")
            .toFormat("dd MMMM yyyy à HH'h'mm")}
        </strong>{" "}
        par <strong>{ep.cancelledBy}</strong>
      </p>
    </div>
  );
};

export default EPCancelledInfo;
